import { registerQuery, useQuery } from 'data-fetching-client';
import { ecosystemAppClient } from 'marketplace-ui-common/clients/ecosystemClient';
export const GET_OAUTH_URL = registerQuery({
  fieldName: 'oauthUrl',
  fetcher: ({
    offeringId,
    published
  }) => ecosystemAppClient.get(`/apps/${offeringId}/oauth-url?published=${published}`)
});
export function useOAuthUrl({
  offeringId,
  published,
  skip
}) {
  var _oauthUrlData$oauthUr;
  const {
    data: oauthUrlData,
    loading: oauthUrlLoading,
    error: oauthUrlError,
    refetch: refetchOAuthUrl
  } = useQuery(GET_OAUTH_URL, {
    skip: skip || !offeringId,
    variables: {
      offeringId,
      published
    },
    fetchPolicy: 'network-only'
  });
  const oauthUrl = oauthUrlData === null || oauthUrlData === void 0 || (_oauthUrlData$oauthUr = oauthUrlData.oauthUrl) === null || _oauthUrlData$oauthUr === void 0 ? void 0 : _oauthUrlData$oauthUr.oauthUrl;
  return {
    oauthUrl,
    oauthUrlLoading,
    oauthUrlError,
    refetchOAuthUrl
  };
}